import { render, staticRenderFns } from "./StatementAvatarCell.vue?vue&type=template&id=1d877ce3&scoped=true&"
import script from "./StatementAvatarCell.vue?vue&type=script&lang=ts&"
export * from "./StatementAvatarCell.vue?vue&type=script&lang=ts&"
import style0 from "./StatementAvatarCell.vue?vue&type=style&index=0&id=1d877ce3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d877ce3",
  null
  
)

export default component.exports